import http from '@/http/aisea/axios'
const resource = "/enterprise/voyage/histories/points";

export default {
  fetch(vesselId, params) {
    return http.get(`${resource}/vessels/${vesselId}`, {
      params: params
    });
  },
  fetchFuelEconomy(voyageId) {
    return http.get(`${resource}/fuel/economy/${voyageId}`);
  }
};
